import { AfterViewInit, Component, OnInit } from '@angular/core';
import * as bootstrap from 'bootstrap';

declare var $: any

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {

  isCopyEmail = false

  address = [
    '21,111 Lakeshore Road',
    'Ste-Anne-de-Bellevue',
    'QC, H9X 3V9, Canada'
  ]

  researchInterests = [
    'High-throughput plant phenotyping using computer vision and deep learning, etc.',
    '3D point cloud reconstruction, registration, and segmentation',
    'Spatio-temporal variation pattern modeling/predication for crop shoots and roots',
    'Multi-source imaging data fusion, such as LiDAR RGB/thermal imagery, and multispectral/hyperspectral imagery.',
    'Agricultural robotics and automation'
  ]

  currentResearch = {
    title: '',
    url: '',
    type: ''
  }

  baseUrl = ''

  researchs = [
      {
      width: 1920,
      height: 1080,
      title: 'CT scanned root system segmentation from growth medium using deep learning',
      type: 'video',
      url: 'https://shangpenglab.s3.us-east-2.amazonaws.com/case4_360_demo_black_18s.mp4'
    },
    {
      width: 2160,
      height: 3840,
      title: 'Automated plant monitoring and phenotyping platform',
      type: 'video',
      url: 'https://shangpenglab.s3.us-east-2.amazonaws.com/PXL_20260818_220103470.mp4'
    },
    {
      width: 3689,
      height: 1179,
      title: 'Plant shoot segmentation and leaf counting using deep learning',
      type: 'img',
      url: 'https://shangpenglab.s3.us-east-2.amazonaws.com/3D_segmentation.png'
    },
    {
      width: 2048,
      height: 1536,
      title: 'Quadruped robotic dog for assisted pollination',
      type: 'video',
      url: 'https://shangpenglab.s3.us-east-2.amazonaws.com/robot_navigation.mp4'
    },
    {
      width: 1920,
      height: 1080,
      title: 'Soybean root system segmentation',
      type: 'img',
      url: 'https://shangpenglab.s3.us-east-2.amazonaws.com/soybean_segmentation_skeleton.gif'
    },
    {
      width: 1920,
      height: 1080,
      title: 'Occlusion-resilient strawberry fruit counting',
      type: 'video',
      url: 'https://shangpenglab.s3.us-east-2.amazonaws.com/strawberry_demo.mp4'
    },
    {
      width: 1280,
      height: 720,
      title: 'CT scan soybean root systems',
      type: 'video',
      url: 'https://shangpenglab.s3.us-east-2.amazonaws.com/CT-scan-soybean.mp4'
    },
    {
      width: 1920,
      height: 1080,
      title: '3D canopy reconstruction using LiDAR and GPS',
      type: 'video',
      url: 'https://shangpenglab.oss-us-east-1.aliyuncs.com/research/3d-canopy-reconstruction.mp4'
    },
    {
      width: 2560,
      height: 1296,
      title: '3D cotton boll detection',
      type: 'video',
      url: 'https://shangpenglab.oss-us-east-1.aliyuncs.com/research/3d-fruit-detection.mp4'
    },
    {
      width: 2542,
      height: 1328,
      title: '3D plant skeleton and node detection',
      type: 'video',
      // type: 'img',
      // url: 'https://shangpenglab.oss-us-east-1.aliyuncs.com/research/3d-plant-skeleton-and-node-detection.gif'
      url: 'https://shangpenglab.oss-us-east-1.aliyuncs.com/research/3d-plant-skeleton-and-node-detection.mp4'
    },
    {
      width: 2560,
      height: 1440,
      title: 'Root point cloud using structure from motion',
      type: 'video',
      url: 'https://shangpenglab.oss-us-east-1.aliyuncs.com/research/root.mp4'
    },
    {
      width: 1574,
      height: 1080,
      title: 'Infield plant point clouds using a 3D laser scanner',
      type: 'video',
      // type: 'img',
      // url: 'https://shangpenglab.oss-us-east-1.aliyuncs.com/research/pts-in-fields.gif'
      url: 'https://shangpenglab.oss-us-east-1.aliyuncs.com/research/pts-in-fields.mp4'
    },
    {
      width: 1024,
      height: 669,
      title: 'Point cloud segmentation and registration',
      type: 'img',
      url: 'https://shangpenglab.oss-us-east-1.aliyuncs.com/research/pt-segmentation.png'
    },
  ]

  scholarships = [
    {
      level: 'PhD',
      opportunities: [
        {
          title: 'McGill MEDA',
          url: 'https://www.mcgill.ca/engineering/students/graduate-students/funding/meda'
        },
        {
          title: 'CSC',
          url: 'https://www.mcgill.ca/gps/funding/international/csc-chinese-students'
        },
        {
          title: 'Quebec-China Scholarship',
          url: 'http://www.csc.edu.cn/article/904'
        },
        {
          title: 'PBEEE Level 1 Graduate',
          url: 'https://www.mcgill.ca/gps/funding/fac-staff/awards/pbeee'
        },
        {
          title: 'Quebec DFW',
          url: 'http://www.csc.edu.cn/chuguo/s/1250'
        }
      ]
    },
    {
      level: 'Postdoc',
      opportunities: [
        {
          title: 'Miatcs Elevate',
          url: 'http://www.mitacs.ca/en/programs/elevate'
        },
        {
          title: 'NSERC Banting (best in Canada)',
          url: 'http://banting.fellowships-bourses.gc.ca/en/home-accueil.html'
        },
        {
          title: 'NSERC Postdoctoral Fellowship',
          url: 'http://www.nserc-crsng.gc.ca/Students-Etudiants/PD-NP/PDF-BP_eng.asp'
        },
        {
          title: 'PBEEE Level 2 Postdoc',
          url: 'https://www.mcgill.ca/gps/funding/international/pbeee'
        },
        {
          title: 'CSC',
          url: 'http://www.csc.edu.cn/chuguo/s/1046'
        }
      ]
    },
    {
      level: 'Undergraduate',
      opportunities: [
        {
          title: 'Mitacs Globalink/international',
          url: 'https://www.mitacs.ca/en/programs/globalink/globalink-research-internship'
        },
        {
          title: 'NSERC USRA',
          url: 'https://www.mcgill.ca/science/research/ours/nserc'
        },
        {
          title: 'McGill SURE',
          url: 'https://www.mcgill.ca/engineering/students/undergraduate/research'
        }
      ]
    }
  ]

  constructor() { }

  ngOnInit(): void {
    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    $('html, body').animate({ scrollTop: 0 }, 0);
  }

  ngAfterViewInit(): void {
    // 计算每一个video或者image的高度，并单独设置
    let h = $('.item-0').height()
    this.researchs.forEach((obj, index) => {
      $('.item-' + index).css('width', obj.width * h / obj.height)
    });
  }

  // 打开模态框
  zoomIn(obj) {
    this.currentResearch = obj
  }

  // 关闭模态框
  closeResearchModal() {
    this.currentResearch = {
      title: '',
      url: '',
      type: ''
    }
  }

  copyEmail(content) {

    this.isCopyEmail = true
    setTimeout(() => {
      this.isCopyEmail = false
    }, 1000);

    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (content));
      e.preventDefault()
      document.removeEventListener('copy', null);
    })
    document.execCommand('copy')


  }

}
